"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestContext = void 0;
exports.default = FormRow2;
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TestEditableCell = _interopRequireDefault(require("./TestEditableCell2"));
var _ykbUtils = require("ykb-utils");
var _tableContext = require("../../Context/tableContext");
var _filterFns = _interopRequireDefault(require("./../../filterFns"));
var _FormContext = require("../../../Form/FormContext");
var _Form = _interopRequireDefault(require("../../../Form"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// #region Form Provider

var TestContext = exports.TestContext = /*#__PURE__*/(0, _react.createContext)(null);
function ConnectedEditableRow(_ref) {
  var form = _ref.form,
    isRowEditing = _ref.isRowEditing,
    children = _ref.children,
    formRef = _ref.formRef,
    rowKey = _ref.rowKey;
  // let formRef = eventHub.getState("form");
  formRef.current = form;
  return /*#__PURE__*/_react.default.createElement(_FormContext.FormProvider, {
    formContext: {
      form: form
    }
  }, /*#__PURE__*/_react.default.createElement(TestContext.Provider, {
    value: formRef
  }, children));
}
var EditableFormRow = _Form.default.create()(ConnectedEditableRow);

// #endregion

function FormRow2(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isRowEditing = _useState2[0],
    setIsRowEditing = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isDeleted = _useState4[0],
    setIsDeleted = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isExpanded = _useState6[0],
    setIsExpanded = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    isFiltered = _useState8[0],
    setIsFiltered = _useState8[1];
  var isFilteredRef = (0, _react.useRef)();
  var filteredColumns = (0, _react.useRef)([]);
  var filterParams = (0, _react.useRef)({});
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    hierarchicallyFilterIgnore = _useState10[0],
    setHierarchicallyFilterIgnoreRef = _useState10[1];
  var hierarchicallyFilteredRowKeys = (0, _react.useRef)({});
  var _useState11 = (0, _react.useState)(_tableContext.eventHub.getState('expandable')),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    expandable = _useState12[0],
    setExpandable = _useState12[1];
  var index = props.index,
    prefixCls = props.prefixCls,
    rowKey = props.rowKey,
    row = props.row,
    rowIndex = props.rowIndex,
    parentRowIndex = props.parentRowIndex,
    rowSelectionEnable = props.rowSelectionEnable,
    parentRowKey = props.parentRowKey,
    parentCollapsed = props.parentCollapsed,
    checkfilterDidMount = props.checkfilterDidMount,
    checkFilterHierarchicallyUp = props.checkFilterHierarchicallyUp,
    showChildForFilter = props.showChildForFilter;
  var _useState13 = (0, _react.useState)(row),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    innerRowValue = _useState14[0],
    setInnerRowValue = _useState14[1];
  var _useState15 = (0, _react.useState)(_tableContext.eventHub.getState('columns')),
    _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
    columns = _useState16[0],
    setColumns = _useState16[1];
  var rowFormRef = (0, _react.useRef)();
  var innerRowValueRef = (0, _react.useRef)(row);
  var expandedRowKeysRef = (0, _react.useRef)();
  var depth = props.depth || 0;
  var preparedClass = prefixCls + '-row ';
  var rowStyle = props.rowStyle || function () {
    return 'default';
  };
  var rowUuid = "row-".concat(rowKey);
  var depthprefix = (0, _ykbUtils.isNullOrUndefined)(parentRowIndex) ? '' : parentRowIndex + '.';
  var rowId = depthprefix + rowIndex;
  function hasNonDeletedChildren() {
    var deletedRowKeys = _tableContext.eventHub.getState('deletedRowKeys') || [];
    if ((0, _ykbUtils.isNullOrUndefined)(innerRowValue.children)) {
      return false;
    }
    if (Array.isArray(innerRowValue.children) && innerRowValue.children.length == 0) {
      return true;
    }
    return innerRowValue.children.filter(function (child) {
      return !deletedRowKeys.some(function (val) {
        return val == child.key;
      });
    }).length > 0;
  }

  // const hasChildren = !isNullOrUndefined(innerRowValue.children);
  var hasChildren = hasNonDeletedChildren();
  var getRowKey = _tableContext.eventHub.getState('getRowKey');
  (0, _react.useEffect)(function () {
    if (checkfilterDidMount && Object.keys(checkfilterDidMount).length) {
      checkFilter(checkfilterDidMount);
    }
    var unsubscriber = [_tableContext.eventHub.on("isEditing.".concat(rowKey), setIsRowEditing), _tableContext.eventHub.on("isDeleted.".concat(rowKey), setIsDeleted), _tableContext.eventHub.on("update.row.".concat(rowKey), updateRow), _tableContext.eventHub.on("update.row.byfilter.".concat(rowKey), updateRowByFilter), _tableContext.eventHub.on("get.rowData.".concat(rowKey), function () {
      return innerRowValueRef.current;
    }), _tableContext.eventHub.on("update.row.field.".concat(rowKey), function (field, value) {
      setInnerRowValue(_objectSpread(_objectSpread({}, innerRowValueRef.current), {}, (0, _defineProperty2.default)({}, field, value)));
    }), _tableContext.eventHub.on('update.expandable', setExpandable), _tableContext.eventHub.on('update.columns', setColumns), _tableContext.eventHub.on('update.filters.formrow', checkFilter)];
    return function () {
      unsubscriber.forEach(function (fn) {
        return fn();
      });
    };
  }, []);
  var lastChildrenLength = innerRowValueRef.current.children ? innerRowValueRef.current.children.length : 0;
  var checkfilterDidMountParams = (0, _react.useRef)({});
  if (innerRowValue.children && innerRowValue.children.length && innerRowValue.children.length != lastChildrenLength) {
    checkfilterDidMountParams.current = _objectSpread({}, filterParams.current);
  }
  innerRowValueRef.current = _objectSpread({}, innerRowValue);
  (0, _react.useEffect)(function () {
    setInnerRowValue(row);
  }, [row]);
  (0, _react.useEffect)(function () {
    expandedRowKeysRef.current = expandable.expandedRowKeys;
    if (!filteredColumns.current.length) {
      var expandStatus = expandable.expandedRowKeys[rowId];
      setIsExpanded(!!expandStatus);
    }
  }, [expandable.expandedRowKeys]);
  function checkFilterHierarchicallyUpCallback(childRowKey, status) {
    // status ; true => child showing && false => child filtering
    hierarchicallyFilteredRowKeys.current[childRowKey] = status;
    setIsFiltered(!isFilterIgnore());
    if (isFilterIgnore()) {
      if (typeof expandable.onExpandByFilter == 'function') {
        expandable.onExpandByFilter(rowId);
      }
      setIsExpanded(true);
    }
    if (parentRowKey && typeof checkFilterHierarchicallyUp == 'function') {
      checkFilterHierarchicallyUp(rowKey, isFilterIgnore());
    }
  }
  function updateRow() {
    var _filters = _tableContext.eventHub.getState('filters');
    setInnerRowValue.apply(void 0, arguments);
    checkFilter(_filters, true);
  }
  function updateRowByFilter() {
    setInnerRowValue.apply(void 0, arguments);
    setIsExpanded(true);
    setIsFiltered(false);
  }
  function clearFilter() {
    // filtre temizlendiyse satırı göster
    setIsFiltered(false);
    setIsExpanded(!!expandedRowKeysRef.current[rowId]);
    hierarchicallyFilteredRowKeys.current = {};
  }
  function checkFilter(_filterParams, forceFilterForUpdateRow) {
    var hasFilter = Object.keys(_filterParams).length > 0;
    if (!hasFilter) {
      clearFilter();
    }
    if ((0, _ykbUtils.isEqual)(_filterParams, filterParams.current) && !forceFilterForUpdateRow) {
      return;
    } else {
      filteredColumns.current = Object.keys(_filterParams);
      filterParams.current = _filterParams;
    }

    // console.log(`checkFilter ${rowKey}`);

    // key => dataindex
    // val => [filterTypeStr, filterPropsObj, columnDefObj, filteredValuesStrArr]

    var _filterStatus = [];
    for (var _key in _filterParams) {
      var _val = _filterParams[_key];
      var _val2 = (0, _toArray2.default)(_val),
        type = _val2[0],
        params = _val2.slice(1);
      var filterFunc = _filterFns.default[type];
      if (typeof filterFunc === 'function') {
        _filterStatus.push(!filterFunc(innerRowValueRef.current, _val, rowId));
      }
    }
    var _filtered = _filterStatus.some(function (q) {
      return q;
    });
    isFilteredRef.current = _filtered;
    if (isFilterIgnore()) {
      // hiyerarşik olarak açılması gerekiyorsa tekrar filtre için kontrole gerek yok.
      return true;
    }
    setIsFiltered(_filtered);
    if (hasFilter) {
      callRelateds(!_filtered);
    }
    return _filtered;
  }
  function callRelateds(status) {
    /**
     * status
     *  true => show
     *  false => hide
     */
    if (typeof checkFilterHierarchicallyUp == 'function') {
      checkFilterHierarchicallyUp(rowKey, status);
    }

    // if (hasChildren) {
    //   console.log(`update.filters.hierarchically.down.${rowKey} && ${rowKey}`);
    //   eventHub.emit(`update.filters.hierarchically.down.${rowKey}`, status);
    // }
  }
  function isFilterIgnore() {
    return Object.values(hierarchicallyFilteredRowKeys.current).some(Boolean);
  }
  var className = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    'editable-row': true,
    editing: isRowEditing,
    filtered: isFiltered && !showChildForFilter
  }, preparedClass, true), rowStyle(innerRowValue, index), true));
  if (isDeleted) {
    return null;
  }
  function enableListChildren() {
    var childrenListedGroups = _tableContext.eventHub.getState('childrenListedGroups') || [];
    if (filteredColumns.current.length == childrenListedGroups.length && (0, _ykbUtils.isEqual)(filteredColumns.current, childrenListedGroups)) {
      return true;
    }
    return false;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !parentCollapsed && /*#__PURE__*/_react.default.createElement("tr", {
    key: "".concat(rowUuid, "-tr"),
    className: className
  }, columns.map(function (column, index) {
    return /*#__PURE__*/_react.default.createElement(_TestEditableCell.default, {
      columnDef: column,
      row: innerRowValue,
      rowKey: rowKey,
      depth: depth,
      key: "".concat(rowKey, "-").concat(column.dataIndex),
      prefixCls: prefixCls
      // form={rowFormRef}
      ,
      id: "".concat(rowId, "_").concat(column.dataIndex),
      cellIndex: index,
      hasChildren: hasChildren,
      isExpanded: isExpanded,
      setIsExpanded: setIsExpanded,
      rowId: rowId,
      rowIndex: rowIndex,
      expandable: expandable,
      isFiltered: isFiltered && !showChildForFilter,
      isActiveFilter: !!filteredColumns.current.length,
      showChildForFilter: showChildForFilter
    });
  })), hasChildren && innerRowValue.children.map(function (_row, index) {
    var _rowKey = typeof getRowKey == 'function' ? getRowKey(_row) : _row[getRowKey];
    return /*#__PURE__*/_react.default.createElement(FormRow2, {
      row: _row,
      prefixCls: prefixCls,
      rowKey: _rowKey,
      key: _rowKey,
      depth: depth + 1,
      rowIndex: index,
      rowStyle: rowStyle,
      parentRowIndex: rowId,
      parentRowKey: rowKey,
      rowSelectionEnable: rowSelectionEnable,
      parentCollapsed: isExpanded && parentCollapsed || !isExpanded,
      checkfilterDidMount: checkfilterDidMount || checkfilterDidMountParams.current,
      checkFilterHierarchicallyUp: checkFilterHierarchicallyUpCallback,
      showChildForFilter: Object.keys(filterParams.current).length > 0 && (isFilteredRef.current == false || showChildForFilter) && enableListChildren()
    });
  }));
}